
<app-total-balance-chart [data]="data()" [loading]="resource.isLoading()"></app-total-balance-chart>
